/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ask_4Inputs */

const en_cp_ask_4 = /** @type {(inputs: Cp_Ask_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The institution's logo may be shown as a partner (Campus Partner)`)
};

const id_cp_ask_4 = /** @type {(inputs: Cp_Ask_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo institusi boleh dipajang sebagai mitra (Kampus Mitra)`)
};

/**
* | output |
* | --- |
* | "The institution's logo may be shown as a partner (Campus Partner)" |
*
* @param {Cp_Ask_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ask_4 = /** @type {((inputs?: Cp_Ask_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ask_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ask_4(inputs)
	return en_cp_ask_4(inputs)
});